import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import {
    Box,
    Typography,
    Paper
} from '@mui/material';
import CASManagement from '../components/Admin/CASManagement';

const CASAdminPage = () => {
    const { user } = useAuth();

    // Check if user has admin access
    if (!user || (user.role !== 'admin' && user.role !== 'superadmin')) {
        return (
            <Box sx={{ p: 3 }}>
                <Typography variant="h6" color="error">
                    Access Denied: Admin privileges required
                </Typography>
            </Box>
        );
    }

    return (
        <Box sx={{ p: { xs: 1, sm: 3 } }}>
            <Typography variant="h4" gutterBottom>
                CAS Administration
            </Typography>
            <Typography variant="body1" color="textSecondary" sx={{ mb: 3 }}>
                Manage content analysis operations, batch processing, and system history.
            </Typography>

            {/* CAS Management Component */}
            <Paper sx={{ mt: 3 }}>
                <Box sx={{ p: { xs: 1, sm: 3 } }}>
                    <CASManagement externalActiveTab={null} />
                </Box>
            </Paper>
        </Box>
    );
};

export default CASAdminPage;
